import React, { useEffect, useRef, useState } from 'react';
import { secondsToDhms, secondsToDhmsFormat } from '../../utils/utilities';

export default function Timer(props) {
    const { duration, useServeTime, serveTime, questionDuration, serverTime } = props;
    const [timeDuration, setTimeDuration] = useState(duration > 0 ? duration : 0);
    const timeDurationRef = useRef(duration > 0 ? duration : 0);
    const timerRef = useRef();

    const updateTime = () => {
        if (timeDurationRef.current <= 0) return;
        timeDurationRef.current--;
        setTimeDuration(timeDurationRef.current);
        props?.getUpdatedTime(timeDurationRef.current);
        timerRef.current = setTimeout(() => updateTime(), 1000);
    };

    const updateTimeWithServeTime = () => {
        if (timeDurationRef.current <= 0) return;
        timeDurationRef.current--;
        setTimeDuration(timeDurationRef.current);
        props?.getUpdatedTime(timeDurationRef.current);
        timerRef.current = setTimeout(() => updateTimeWithServeTime(), 1000);
    };

    useEffect(() => {
        if (useServeTime && serveTime && questionDuration && serverTime) {
            // Clear any existing timer
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }

            // Calculate elapsed time using ONLY server times - no local time
            const serveTimeMs = new Date(serveTime).getTime();
            const currentServerTimeMs = new Date(serverTime).getTime();

            const elapsedSeconds = Math.floor((currentServerTimeMs - serveTimeMs) / 1000);

            // Calculate remaining time
            const remainingTime = Math.max(0, questionDuration - elapsedSeconds);

            // Check if time has already exceeded
            if (remainingTime <= 0) {
                // Time has expired
                timeDurationRef.current = 0;
                setTimeDuration(0);
                props?.getUpdatedTime(0);
                return;
            }

            // Set the remaining time and start countdown from there
            timeDurationRef.current = remainingTime;
            setTimeDuration(remainingTime);
            props?.getUpdatedTime(remainingTime);

            // Start the countdown
            updateTimeWithServeTime();

            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                    timerRef.current = null;
                }
            };
        } else {
            // Use original timer logic for non-serve-time based timers
            if (!duration) return;
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }

            timeDurationRef.current = duration;
            updateTime();

            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                    timerRef.current = null;
                }
                timeDurationRef.current = null;
            };
        }
    }, [useServeTime ? serveTime : duration, questionDuration, serverTime]);

    return (
        <>
            {
                (duration !== null || (useServeTime && serveTime)) &&
                <span className={`${props.isCaseStudy ? 'subtitle-2' : 'subtitle-2'} ${timeDuration <= 30 ? 'danger-text' : 'dark-100'}`} style={{ ...props.style }}>
                    {timeDuration > 0
                        ? (props.isCaseStudy
                            ? secondsToDhmsFormat(timeDuration, true)
                            : secondsToDhms(timeDuration))
                        : "0 sec"}
                </span>
            }
        </>
    );
}